import { ErrorResponse } from "./error-response";

export class ServiceResponse<T> {
    status: string;
    data: T;
    error: ErrorResponse
};